import React from "react";
import DatePicker from "react-datepicker";
import "../../../resources/styles.scss";
import { withRouter } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import { connect } from 'react-redux';


class EditTankOperation extends React.Component {
    constructor(props) {
        super(props);
        const tankId = parseInt(this.props.match.params.id);
        this.state = {
            item: {
                tankId: tankId,
                fuelType: "",
                provider: "",
                description: "",
                balance: 0,
                deliveryDate: new Date()
            }
        }

        this.onDateChanged = this.onDateChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    onDateChanged(date) {
        let newState = Object.assign({}, this.state);
        newState.item.deliveryDate = date;
        this.setState(newState);
    }

    handleSubmit(e) {
        e.preventDefault();
        let newState = Object.assign({}, this.state);
        newState.item.fuelType = this.refs.fuelType.value;
        newState.item.provider = this.refs.provider.value;
        newState.item.description = this.refs.description.value;

        const balance = parseFloat(this.refs.balance.value);
        newState.item.balance = balance;
        //newState.item.deliveryDate = this.refs.deliveryDate.value;
        this.setState(newState);

        this.props.addTankOperation(newState.item);
    }

    cancel(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="form_container">
                <form className="edit-form" onSubmit={this.handleSubmit}>
                    <div className="form-body">
                        <p>
                            <label><Trans>TankOperation.fuelType</Trans></label>
                            <input type="text" ref="fuelType" defaultValue={this.state.item.fuelType} />
                        </p>
                        <p>
                            <label><Trans>TankOperation.provider</Trans></label>
                            <input type="text" ref="provider" defaultValue={this.state.item.provider} />
                        </p>
                        <p>
                            <label><Trans>TankOperation.description</Trans></label>
                            <input type="text" ref="description" defaultValue={this.state.item.description} />
                        </p>
                        <p>
                            <label><Trans>TankOperation.balance</Trans></label>
                            <input type="number" ref="balance" defaultValue={this.state.item.balance} step="any"/>
                        </p>
                        <div>
                            <label><Trans>TankOperation.deliveryDate</Trans></label>
                            <DatePicker selected={this.state.item.deliveryDate}
                                onChange={date => this.onDateChanged(date)}
                                timeFormat="HH:mm"
                                        showTimeInput
                                        timeIntervals={1}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                placeholderText={this.props.t("date")} />
                        </div>
                        <div className="form-buttons-container">
                            <button type="submit"><Trans>Table.saveButton</Trans></button>
                            <button onClick={this.cancel}><Trans>Table.cancelButton</Trans></button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        addTankOperation: tankOperation => dispatch(actionTanks.addTankOperation(tankOperation, ownProps))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation("translations")(EditTankOperation)));